import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Button, TextField, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { ICharacter } from '../../../../../../../../../../api/types/character'
import { useShow } from '../../../../../../../../../../hooks/useShow'
import { useApiErrors } from '../../../../../../../../../../hooks/useApiErrors'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationCreateAction } from '../../../../../../../../../../api/mutations'
import { pendingActionsQueryKey } from '../../../../../../../../../../api/queries'
import {
  DialogActions,
  DialogContent,
  Modal,
} from '../../../../../../../../../../components/Modal/Modal'
import { SubmitButton } from '../../../../../../../../../../components/SubmitButton/SubmitButton'
import { FormRow } from '../../../../../../../../../../components/FormRow/FormRow'
import { ErrorExplanation } from '../../../../../../../../../../components/ErrorExplanation/ErrorExplanation'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    action: {
      margin: theme.spacing(0.5),
      flexGrow: 1,
    },
  })
)

interface Props {
  character: ICharacter
  game_id?: number
  name: string
  action_type: string
  icon?: React.ReactNode
}

interface IModValue {
  mod: number
}

export const ModifyAttributeAction: React.FC<Props> = ({
  game_id,
  character,
  name,
  icon,
  action_type,
}) => {
  const classes = useStyles()
  const { show, doHide, doShow } = useShow()
  const { apiErrors, setApiErrors, setApiErrorsFromAxios } = useApiErrors()
  const { register, handleSubmit, errors } = useForm<IModValue>()
  const queryClient = useQueryClient()

  const { mutate: createActionMutation, isLoading: isMutating } = useMutation(
    (mod: IModValue) =>
      mutationCreateAction({
        game_id: game_id || 0,
        character_id: character.id,
        action_type: action_type,
        params: String(mod.mod),
      }),
    {
      onError: (err: any) => {
        setApiErrorsFromAxios(err, 'Nie udało się stworzyć akcji')
      },
      onSuccess: async () => {
        setApiErrors([])
        queryClient.invalidateQueries(pendingActionsQueryKey(Number(game_id))).then(doHide)
      },
    }
  )

  return (
    <>
      {game_id && (
        <>
          <Button
            onClick={() => {
              setApiErrors([])
              doShow()
            }}
            startIcon={icon}
            className={classes.action}
            variant="outlined"
            color="primary"
          >
            {name}
          </Button>

          <Modal open={show} onClose={doHide} title="Wykonaj akcję">
            <form onSubmit={handleSubmit((mod: IModValue) => createActionMutation(mod))}>
              <DialogContent dividers>
                <FormRow>
                  <ErrorExplanation errors={apiErrors} />
                </FormRow>
                <FormRow>
                  <TextField
                    name="mod"
                    type="number"
                    defaultValue={0}
                    label="Modyfikator"
                    fullWidth={true}
                    variant="outlined"
                    inputProps={{
                      ref: register({
                        required: 'Wymagane',
                      }),
                    }}
                    error={!!errors.mod}
                    helperText={errors.mod && errors.mod.message}
                  />
                </FormRow>
              </DialogContent>
              <DialogActions>
                <SubmitButton disabled={isMutating}>Create</SubmitButton>
              </DialogActions>
            </form>
          </Modal>
        </>
      )}
    </>
  )
}
